export const GET_RESPONSE_SUCCESS = "CHAT/GET_RESPONSE_SUCCESS";
export const GET_RESPONSE_FAILURE = "CHAT/GET_RESPONSE_FAILURE";

export const GET_EVENT_DATA = "CHAT/GET_EVENT_DATA";

export const JOIN_ROOM_REQUEST = "CHAT/JOIN_ROOM_REQUEST";
export const POST_MESSAGE_REQUEST = "CHAT/POST_MESSAGE_REQUEST";
export const READ_MESSAGE_REQUEST = "CHAT/READ_MESSAGE_REQUEST";
export const GET_UNREAD_MESSAGES_COUNT_REQUEST = "CHAT/GET_UNREAD_MESSAGES_COUNT_REQUEST";
export const EVENT_ON_JOIN = "CHAT/EVENT_ON_JOIN";
export const EVENT_ON_MESSAGE = "CHAT/EVENT_ON_MESSAGE";
export const EVENT_ON_READ = "CHAT/EVENT_ON_READ";
export const EVENT_ON_LEAVE = "CHAT/EVENT_ON_LEAVE";
export const LEAVE_CHAT = "CHAT/LEAVE_CHAT";
export const GET_MESSAGES_REQUEST = "CHAT/GET_MESSAGES_REQUEST";
export const GET_MESSAGES_SUCCESS = "CHAT/GET_MESSAGES_SUCCESS";
export const GET_MESSAGES_FAILURE = "CHAT/GET_MESSAGES_FAILURE";
export const RESET_MESSAGES = "CHAT/RESET_MESSAGES";
export const GET_USERS_SUCCESS = "CHAT/GET_USERS_SUCCESS";
export const EVENT_ON_RECONNECT = "CHAT/EVENT_ON_RECONNECT";
export const RESET_STATE = "CHAT/RESET_STATE";
export const ON_CONNECT = "CHAT/ON_CONNECT";
export const ON_DISCONNECT = "CHAT/ON_DISCONNECT";
export const ON_CONNECT_SUCCESS = "CHAT/ON_CONNECT_SUCCESS";
export const ON_NEW_USER = "CHAT/ON_NEW_USER";
export const SET_DENTIST = "CHAT/SET_DENTIST";
export const GET_CHAT_DENTISTS = "GET_CHAT_DENTISTS";
export const GET_CHAT_DENTISTS_SUCCESS = "GET_CHAT_DENTISTS_SUCCESS";
export const GET_CHAT_DENTISTS_FAILURE = "GET_CHAT_DENTISTS_FAILURE";






// WEBPACK FOOTER //
// ./src/containers/Chat/constants.js